<template>
  <div class="main-content">
    <MainPromo />

    <div class="substrate --gray-gradient --details">
      <div class="container">
        <MainProductsBlockDesktop />
        <LazyHydrate when-visible>
          <LazyLeaderVKSBlockDesktop />
        </LazyHydrate>
      </div>
    </div>

    <div class="substrate --with-img">
      <div class="substrate__bg-wrapper">
        <picture>
          <source
            srcset="~/assets/img/main/main-promo-bg.webp"
            type="image/webp"
          />
          <img
            :src="require(`~/assets/img/main/main-promo-bg.png`)"
            alt=""
          />
        </picture>
      </div>
      <div class="container">
        <LazyHydrate when-visible>
          <LazyOnPremiseBlockDesktop />
        </LazyHydrate>
      </div>
    </div>
    <div class="substrate --for-reviews">
      <div class="container">
        <LazyHydrate when-visible>
          <LazyReviewsBlockDesktop />
        </LazyHydrate>
      </div>
    </div>
    <div class="container">
      <LazyHydrate when-visible>
        <LazyAdvantagesBlockDesktop />
      </LazyHydrate>
    </div>

    <div class="substrate --gray-bg">
      <div class="container">
        <LazyHydrate when-visible>
          <LazyMainFAQBlockDesktop />
        </LazyHydrate>
      </div>
    </div>
  </div>
</template>

<script>
import LazyHydrate from 'vue-lazy-hydration'
import EventBus from '@/mixins/EventBus'
import MainMixin from '~/components/Page/Main/MainMixin'
import LazyAdvantagesBlockDesktop from '~/components/Desktop/Main/Lazy/LazyAdvantagesBlockDesktop.vue'
import LazyMainFAQBlockDesktop from '~/components/Desktop/Main/Lazy/LazyMainFAQBlockDesktop.vue'
import LazyLeaderVKSBlockDesktop from '~/components/Desktop/Main/Lazy/LazyLeaderVKSBlockDesktop.vue'
import LazyOnPremiseBlockDesktop from '~/components/Desktop/Main/Lazy/LazyOnPremiseBlockDesktop.vue'
import MainProductsBlockDesktop from '~/components/Desktop/Main/MainProductsBlockDesktop.vue'
import LazyReviewsBlockDesktop from '~/components/Desktop/Main/Lazy/LazyReviewsBlockDesktop.vue'
import MainPromo from '@/components/NewDesign/Page/Index/Parts/Promo/MainPromo.vue'

export default {
  name: 'MainPageDesktop',
  components: {
    MainPromo,
    LazyOnPremiseBlockDesktop,
    LazyLeaderVKSBlockDesktop,
    MainProductsBlockDesktop,
    LazyMainFAQBlockDesktop,
    LazyReviewsBlockDesktop,
    LazyAdvantagesBlockDesktop,
    LazyHydrate,
  },
  mixins: [EventBus, MainMixin],
}
</script>

<style lang="scss" scoped>
.main-content {
  font-family: $font-mts-compact;

  .container {
    max-width: 1440px;
    padding-left: 32px;
    padding-right: 32px;
  }

  .substrate {
    &.--with-img {
      padding: 32px 0;
      position: relative;

      .substrate__bg-wrapper {
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        z-index: -1;
        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }
    }
    &.--gray-bg {
      background: $color-gray-2;
    }
    &.--gray-gradient {
      background: linear-gradient(180deg, #f2f3f7 0%, #ffffff 100%);
    }
    &.--details {
      border: 1px solid #BCC3D080;
      border-radius: 32px 32px 0 0;
    }
  }
}
</style>
